import React from 'react';
import { ItemType, ProductSelection, ProductType } from 'components/ProductsSelection/types';
import { Spinner, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import './styles.scss';

export interface SelectedOptionsProps {
  loading: boolean;
  total: number;
  appliedSelection: ProductSelection;
  currentProductType: ProductType;
  label: string;
  onRemoveAll(currentProductType: ProductType): void;
  onRemoveItem(currentProductType: ProductType, item: ItemType): void;
  isGroupsFilter: boolean;
  editable?: boolean;
}

export const SelectedOptions = ({
  loading,
  total,
  appliedSelection,
  currentProductType,
  label,
  onRemoveAll,
  onRemoveItem,
  isGroupsFilter,
  editable = true,
}: SelectedOptionsProps) => {
  return (
    <div className="container">
      <div className="section-title">
        <div className="section-label">{label}</div>
        {loading ? (
          <Spinner className="spinner" animation="border" size="sm" />
        ) : (
          <>
            ({total})
            {editable && isGroupsFilter && (
              <Button className="btn_remove_all" onClick={() => onRemoveAll(currentProductType)}>
                <FontAwesomeIcon icon={faTimes} />
              </Button>
            )}
          </>
        )}
      </div>
      <div className="items">
        {appliedSelection[currentProductType].map((item) => {
          return (
            <div key={item.id} className="item">
              <div className="item-label">{item.label}</div>
              {editable && isGroupsFilter && (
                <Button
                  data-testid={item.id}
                  className="btn_remove"
                  onClick={() => onRemoveItem(currentProductType, item)}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </Button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
